import React from 'react';
import { FadeIn } from './FadeIn';
import { Download, Backpack, ShieldCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Descarga',
    desc: 'Descarga el Protocolo y los Checklists en tu teléfono o imprímelos.',
    icon: <Download className="w-8 h-8" data-id="element-91" />
  }, {
    num: '02',
    title: 'Arma',
    desc: 'Sigue la lista "Caja Negra" para armar tu mochila en menos de una hora con cosas que ya tienes en casa.',
    icon: <Backpack className="w-8 h-8" data-id="element-92" />
  }, {
    num: '03',
    title: 'Duerme Tranquilo',
    desc: 'Duerme con la tranquilidad de que, si suena la alarma, tu familia está a 15 minutos de la seguridad total.',
    icon: <ShieldCheck className="w-8 h-8" data-id="element-93" />
  }];
  return <section className="py-24 px-4 bg-brand-gray border-y border-brand-border" data-id="element-94">
      <div className="max-w-6xl mx-auto" data-id="element-95">
        <FadeIn data-id="element-96">
          <div className="text-center mb-20" data-id="element-97">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white uppercase" data-id="element-98">
              Cómo Funciona
            </h2>
            <p className="text-xl text-gray-400 mt-4" data-id="element-99">
              3 pasos simples para blindar a tu familia hoy
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-100">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-brand-border z-0" data-id="element-101" />

          {steps.map((step, i) => <FadeIn key={i} delay={i * 0.2} className="relative z-10" data-id="element-102">
              <div className="flex flex-col items-center text-center" data-id="element-103">
                <div className="w-24 h-24 bg-brand-dark rounded-full border-4 border-brand-orange flex items-center justify-center text-brand-orange mb-6 shadow-[0_0_30px_rgba(255,102,0,0.2)]" data-id="element-104">
                  {step.icon}
                </div>
                <span className="text-brand-orange font-display font-bold text-2xl mb-2" data-id="element-105">
                  {step.num}
                </span>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-106">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-107">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}